// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","538":"c8e26dd5","842":"e3605139","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"218":"38105abc2b612c0cd687","538":"16234eacb66fa620a2e3","842":"ffaf42599d4ce501af0c","895":"c3340c2e2839079b5f73"}[chunkId] + ".js";
};